import { IModel } from "../contracts/IModel";

export class SignInModel implements IModel {
    Username!:string;
    Password!:string;
    RememberMe!:boolean;
}